module.exports = __webpack_public_path__ + "img/charging-hub-request-private.42b7783d.png";